import React from "react";

import { Box, BoxProps } from "@catchoftheday/cg-components";
import { styled } from "@catchoftheday/theme";

import { HEADER_XMAS_TILE } from "../../../consts";
import { EventTheme } from "../../../types";

export type BackgroundTileProps = {
  eventTheme?: EventTheme;
} & BoxProps;

type TileProps = {
  getTile: () => string;
} & BackgroundTileProps;

const Tile = styled(Box)<TileProps>`
  ${(props) => props.eventTheme && `background-image: url(${props.getTile()})`}
`;

export const BackgroundTile: React.FC<BackgroundTileProps> = ({
  children,
  ...props
}) => {
  const getTile = () => {
    switch (props.eventTheme) {
      case "christmas":
        return HEADER_XMAS_TILE;
      default:
        return "";
    }
  };

  return (
    <Tile {...props} getTile={getTile}>
      {children}
    </Tile>
  );
};
